import React, {
  Children,
  Dispatch,
  SetStateAction,
  useCallback,
  useMemo,
  MouseEvent
} from 'react'
import cn from 'classnames'
import AccordionContext from './Accordion.Context'

import * as S from './Accordion.styled'

interface AccordionProps {
  className?: string
  expanded?: boolean | string
  setExpanded: Dispatch<SetStateAction<string | boolean>>
}

const Accordion: React.FC<AccordionProps> = ({
  className,
  expanded = false,
  setExpanded,
  children
}) => {
  const isExpanded = useCallback(
    (slug: string | undefined) => expanded === slug,
    [expanded]
  )

  const toggle = useCallback(
    (e: MouseEvent<HTMLElement>, slug: string) => {
      e.preventDefault()
      setExpanded(isExpanded(slug) ? false : slug)
    },
    [expanded]
  )

  const context = useMemo(
    () => ({
      isExpanded,
      toggle
    }),
    [expanded]
  )

  const [heading, ...body] = Children.toArray(children)

  return (
    <AccordionContext.Provider value={context}>
      <S.Wrapper className={cn(className)}>
        {heading}
        {body}
      </S.Wrapper>
    </AccordionContext.Provider>
  )
}

export default Accordion
